
export default () => {
  const openNewTab = (url: string | null) => {
    if (!url) return;
    window.open(url, '_blank');
  };

  return { state: {}, funcs: { openNewTab } };
};
